import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
function escapeHtml(input) {
    return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
export const MarkdownRenderer = ({ content, className }) => {
    const raw = String(content !== null && content !== void 0 ? content : '');
    // Normalize newlines and keep literal "\n"
    const normalized = raw.replace(/\r\n|\r/g, '\n').replace(/\\n/g, '\n');
    // Escape HTML to prevent injections
    const escaped = escapeHtml(normalized);
    // Very simple bold: **text** -> <strong>text</strong>
    const withBold = escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Convert newlines to <br/>
    const withBreaks = withBold.replace(/\n/g, '<br/>');
    return _jsx("div", { className: className, dangerouslySetInnerHTML: { __html: withBreaks } });
};
export default MarkdownRenderer;
